/**
 * Continue-shopping link — shared by cart drawer and cart page.
 *
 * Points [data-continue-shopping] links at the most recently viewed
 * product (localStorage 'drhoelter_recently_viewed', written by
 * snippets/recently-viewed-tracker.liquid; functional storage, owner
 * decision 2026-10-01). Falls back to the link's server-rendered href.
 *
 * Drawer on a product page (data-close-on-product="true"): the link only
 * closes the drawer — the customer is already where they came from.
 */
(function (root) {
  var STORAGE_KEY = 'drhoelter_recently_viewed';
  var HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/i;

  function firstHandle(storageValue) {
    if (!storageValue) return null;
    var parsed;
    try {
      parsed = JSON.parse(storageValue);
    } catch (e) {
      return null;
    }
    if (!Array.isArray(parsed) || parsed.length === 0) return null;
    var entry = parsed[0];
    var handle = typeof entry === 'string' ? entry : entry && entry.handle;
    return typeof handle === 'string' && HANDLE_PATTERN.test(handle) ? handle : null;
  }

  function resolveContinueUrl(options) {
    var handle = firstHandle(options.storageValue);
    if (!handle) return options.fallbackUrl;
    var base = String(options.rootUrl || '/').replace(/\/+$/, '');
    return base + '/products/' + handle;
  }

  function readStorage() {
    try {
      return root.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function updateLink(link, storageValue) {
    if (!link.dataset.fallbackUrl) link.dataset.fallbackUrl = link.getAttribute('href');
    link.href = resolveContinueUrl({
      storageValue: storageValue,
      rootUrl: link.dataset.rootUrl,
      fallbackUrl: link.dataset.fallbackUrl,
    });
  }

  function init(doc) {
    // Drawer and cart page both load this file; bind once.
    if (root.__drhContinueShopping) return;
    root.__drhContinueShopping = true;
    var storageValue = readStorage();
    doc.querySelectorAll('[data-continue-shopping]').forEach(function (link) {
      if (link.dataset.closeOnProduct !== 'true') updateLink(link, storageValue);
    });
    // Delegated so links inside re-rendered cart sections keep working.
    doc.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-continue-shopping]');
      if (!link) return;
      if (link.dataset.closeOnProduct === 'true') {
        event.preventDefault();
        return;
      }
      updateLink(link, readStorage());
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { resolveContinueUrl: resolveContinueUrl };
  }

  if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', function () { init(root.document); });
    } else {
      init(root.document);
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
